import script from "./ViewImage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewImage.vue?vue&type=script&setup=true&lang=js"

import "./ViewImage.vue?vue&type=style&index=0&id=5fd776dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fd776dc"]])

export default __exports__